import { render, staticRenderFns } from "./EmissionsFactorsTable.vue?vue&type=template&id=7be70cf6"
import script from "./EmissionsFactorsTable.vue?vue&type=script&lang=js"
export * from "./EmissionsFactorsTable.vue?vue&type=script&lang=js"
import style0 from "./EmissionsFactorsTable.vue?vue&type=style&index=0&id=7be70cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports